import { Navigate } from 'react-router-dom';
import { getOrganizationType } from 'lib/organizationType';

export default function AssettechOnly({
  children,
}: {
  children: React.ReactNode;
}) {
  if (getOrganizationType() !== 'assettech') {
    return <Navigate to='/pickups' replace />;
  }
  return <>{children}</>;
}
